/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { SportsHeroModuleContentItem } from './sports-hero-module-content-item';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface SportsHeroUiModuleBody
 */
export interface SportsHeroUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof SportsHeroUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof SportsHeroUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof SportsHeroUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof SportsHeroUiModuleBody
     */
    moduleType: SportsHeroUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof SportsHeroUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof SportsHeroUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof SportsHeroUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof SportsHeroUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof SportsHeroUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {Array<SportsHeroModuleContentItem>}
     * @memberof SportsHeroUiModuleBody
     */
    matchHeroContents: Array<SportsHeroModuleContentItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum SportsHeroUiModuleBodyModuleTypeEnum {
    SPORTS_HERO = 'SPORTS_HERO'
}



